/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";

import IntlMessages from "../../helpers/IntlMessages";
import ApplicationMenu from "../../components/common/ApplicationMenu";
import { getBookingListWithFilter, getBookingListWithOrder } from "../../redux/booking/actions";

class BookingApplicationMenu extends Component {
  addFilter = (column, value) => {
    const { getBookingListWithFilter, bookingApp, getBookingListWithOrder } = this.props;
    getBookingListWithFilter(column, value);
    if (bookingApp?.orderColumn) {
      getBookingListWithOrder(`${bookingApp.orderColumn.column}`, `${bookingApp.orderColumn.direction}`);
    }
  };

  render() {
    const { filter, allBookingItems, loading } = this.props.bookingApp;
    let awaitingCount = 0;
    let hotelGuestCount = 0;
    let invalidCount = 0;
    let checkedCount = 0;

    Object.values(allBookingItems).forEach(booking => {
      if (booking.status === "awaiting_approval") {
        awaitingCount += 1;
      }
      if (booking.status === "hotel_guest") {
        hotelGuestCount += 1;
      }
      if (booking.status === "invalid_booking") {
        invalidCount += 1;
      }
      if (booking.status === "checked_out") {
        checkedCount += 1;
      }
    });

    return (
      <ApplicationMenu>
        <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
          <div className="p-4">
            <p className="text-muted text-small">
              <IntlMessages id="booking.status" />
            </p>

            <ul className="list-unstyled mb-5">
              <NavItem className={classnames({ active: !filter })}>
                <NavLink to="#" onClick={e => this.addFilter("", "")}>
                  <i className="simple-icon-reload" />
                  <IntlMessages id="booking.all-reservations" />
                  <span className="float-right">{!loading && Object.keys(allBookingItems).length}</span>
                </NavLink>
              </NavItem>

              <NavItem
                className={classnames({
                  active: filter && filter.value.indexOf("awaiting_approval") > -1
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "awaiting_approval")}>
                  <i className="simple-icon-exclamation" />
                  <IntlMessages id="booking.status_awaiting_approval" />
                  <span className="float-right">{!loading && awaitingCount}</span>
                </NavLink>
              </NavItem>

              <NavItem
                className={classnames({
                  active: filter && filter.value.indexOf("hotel_guest") > -1
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "hotel_guest")}>
                  <i className="simple-icon-check" />
                  <IntlMessages id="booking.status_hotel_guest" />
                  <span className="float-right">{!loading && hotelGuestCount}</span>
                </NavLink>
              </NavItem>

              <NavItem
                className={classnames({
                  active: filter && filter.value.indexOf("invalid_booking") > -1
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "invalid_booking")}>
                  <i className="simple-icon-close" />
                  <IntlMessages id="booking.status_invalid_booking" />
                  <span className="float-right">{!loading && invalidCount}</span>
                </NavLink>
              </NavItem>

              <NavItem
                className={classnames({
                  active: filter && filter.value.indexOf("checked_out") > -1
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "checked_out")}>
                  <i className="simple-icon-close" />
                  <IntlMessages id="booking.status_checked_out" />
                  <span className="float-right">{!loading && checkedCount}</span>
                </NavLink>
              </NavItem>
            </ul>
          </div>
        </PerfectScrollbar>
      </ApplicationMenu>
    );
  }
}

const mapStateToProps = ({ bookingApp }) => {
  return { bookingApp };
};

const mapActionsToProps = {
  getBookingListWithFilter,
  getBookingListWithOrder
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(BookingApplicationMenu);
